import "./Project.css"
import Navbar from "../../components/navbar/Navbar"
import Footer from "../../components/footer/Footer"

const Project = () => {
  return (
    <>
    <Navbar/>
    <div className="project">
      <div className="projectImages">
        <img src="https://www.jmeightengineering.com/images/articles/borehole-drilling.jpg" alt="" className="projectImage" />
        <img src="https://www.jmeightengineering.com/images/articles/borehole-drilling.jpg" alt="" className="projectImage" />
        <img src="https://www.jmeightengineering.com/images/articles/borehole-drilling.jpg" alt="" className="projectImage" />
        <img src="https://www.jmeightengineering.com/images/articles/borehole-drilling.jpg" alt="" className="projectImage" />
        <img src="https://www.jmeightengineering.com/images/articles/borehole-drilling.jpg" alt="" className="projectImage" />
        <img src="https://www.jmeightengineering.com/images/articles/borehole-drilling.jpg" alt="" className="projectImage" />
      </div>
    </div>
    <Footer/>
    </>
  )
}

export default Project